import { FaPrayingHands } from "react-icons/fa";
import { FaBuildingWheat } from "react-icons/fa6";
import { FaHandHoldingHeart } from "react-icons/fa";

const uniqueFeatures = [
  {
    title: "Every artwork supports a cause",
    description:
      "Art is linked to active impact campaigns that generate real change.",
    image: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-heart-handshake"
      >
        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
        <path d="M12 18H9.5a2.5 2.5 0 0 1 0-5h5c.83 0 1.5.67 1.5 1.5v2.5" />
        <path d="M12 15h2" />
      </svg>
    ),
    bgColor: "bg-accent-dark",
    class: "",
  },
  {
    title: "Collections that tell stories",
    description: "Campaigns are paired with compelling narratives.",
    image: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-book-text"
      >
        <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20" />
        <path d="M8 7h6" />
        <path d="M8 11h8" />
      </svg>
    ),
    bgColor: "bg-accent-dark",
    class: "",
  },
  {
    title: "Artists, communities, and causes co-create",
    description:
      "Art can be contributed directly by individuals to support campaigns.",
    image: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-users"
      >
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87ZM16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
    bgColor: "bg-accent-dark",
    class: "",
  },
  {
    title: "Shared earnings for contributors",
    description:
      "Artists who contribute to campaigns can earn a share of revenue based on their work.",
    image: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-dollar-sign"
      >
        <line x1="12" x2="12" y1="2" y2="22" />
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
      </svg>
    ),
    bgColor: "bg-accent-dark",
    class: "",
  },
  {
    title: "Campaigners build community",
    description: "Reward supporters, grow your network, and deepen engagement.",
    image: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-network"
      >
        <rect x="16" y="2" width="6" height="6" rx="1" />
        <rect x="2" y="16" width="6" height="6" rx="1" />
        <rect x="16" y="16" width="6" height="6" rx="1" />
        <rect x="2" y="2" width="6" height="6" rx="1" />
        <path d="M12 10a4 4 0 0 0-4-4V2" />
        <path d="M12 14a4 4 0 0 0 4 4v4" />
        <path d="M10 12h2" />
        <path d="M16 12h-2" />
        <path d="M12 12V10" />
        <path d="M12 14v-2" />
      </svg>
    ),
    bgColor: "bg-accent-dark",
    class: "",
  },
  {
    title: "Power up campaigns through game engagement",
    description:
      "Include campaign art in our impact games ecosystem to increase engagement and fundraising outcomes.",
    image: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-gamepad"
      >
        <path d="M6 12H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2" />
        <path d="M18 12h2a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-2" />
        <path d="M12 18v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2" />
        <path d="M12 6V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v2" />
        <path d="M12 10a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2" />
        <path d="M12 10a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2" />
        <path d="M15 11h.01" />
        <path d="M9 11h.01" />
      </svg>
    ),
    bgColor: "bg-accent-dark",
    class: "",
  },
  {
    title: "Transparent impact reporting",
    description:
      "Every campaign is verified, with report requirements increasing trust and credibility.",
    image: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-clipboard-list"
      >
        <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
        <path d="M12 11h4" />
        <path d="M12 16h4" />
        <path d="M8 11h.01" />
        <path d="M8 16h.01" />
      </svg>
    ),
    bgColor: "bg-accent-dark",
    class: "",
  },
  {
    title: "Blockchain Options",
    description:
      "Options for art to be added on the blockchain for traceability.",
    image: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-link-2"
      >
        <path d="M9 17H7A5 5 0 0 1 7 7h2" />
        <path d="M15 7h2a5 5 0 0 1 0 10h-2" />
        <line x1="8" x2="16" y1="12" y2="12" />
      </svg>
    ),
    bgColor: "bg-accent-dark",
    class: "",
  },
];

// Data for the 'Who Is It For?' section
const personas = [
  {
    title: "Campaigners & NGOs",
    benefits: [
      "Launch art-based fundraisers that deepen community involvement.",
      "Partner with artists or accept public contributions to diversify your content.",
      "Build a loyal supporter or membership base and reward them with access, recognition, or art.",
    ],
    cta: "Start Your Campaign",
    icon: <FaHandHoldingHeart />,
  },
  {
    title: "Brands & Corporate Partners",
    benefits: [
      "Sponsor or co-create art campaigns that align with your purpose-driven values.",
      "Support artists and causes while building brand trust and visibility.",
      "Track engagement and impact.",
    ],
    cta: "Partner With Us",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-briefcase"
      >
        <rect width="20" height="14" x="2" y="7" rx="2" ry="2" />
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
      </svg>
    ),
  },
  {
    title: "Collectors & Supporters",
    benefits: [
      "Collect art that supports real causes.",
      "See where your money goes and the impact it helps achieve.",
      "Submit art to active campaigns and earn from your contributions.",
      "Share and promote campaigns through the artwork you own or contribute.",
    ],
    cta: "Explore Artwork",
    icon: <FaPrayingHands />,
  },
  {
    title: "Artists & Creatives",
    benefits: [
      "Contribute work to drive awareness and impact.",
      "Submit art to active campaigns and earn from your contributions.",
      "Use your creative voice to contribute directly to causes you care about.",
    ],
    cta: "Contribute Your Art",
    icon: <FaBuildingWheat />,
  },
];

// Data for the 'Why Use Art for Impact Campaigns?' section
const whyUseArt = [
  {
    title: "Art creates connection",
    description: "It transcends barriers and fosters empathy.",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-gem"
      >
        <path d="M6 3v18l6-4 6 4V3Z" />
        <path d="M22 10 12 2 2 10" />
        <path d="M12 22 22 14 2 14Z" />
      </svg>
    ),
  },
  {
    title: "Storytelling transcends barriers",
    description: "Deepening participation and understanding of complex issues.",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-message-square-text"
      >
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        <line x1="9" x2="15" y1="9" y2="9" />
        <line x1="9" x2="13" y1="13" y2="13" />
      </svg>
    ),
  },
  {
    title: "Campaigns bring people together",
    description:
      "Uniting individuals through shared purpose and collective action.",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-hand-heart"
      >
        <path d="M11 11.28a1 1 0 0 0-.34-.7C9.28 9.2 8.2 8.53 7 8c-2.3-1.07-4.5-1.47-5-1.5V5c.4-.2 2.1-.8 5-2 2.7-1.1 5.5-1.5 8-1.5 4.5 0 8 2 8 6.5 0 4.1-3.9 7.4-7.5 7.4H13" />
        <path d="M18 13c-.8.5-2.2 1-3.5 1C12 14 12 20 12 20h2c.7 0 1.3-.7 1.3-1.5v-2.3c0-.7.6-1.2 1.3-1.2H22v-4Z" />
      </svg>
    ),
  },
  {
    title: "Artists and supporters grow their following",
    description: "And earn from meaningful contributions.",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-trending-up"
      >
        <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
        <polyline points="16 7 22 7 22 13" />
      </svg>
    ),
  },
  {
    title: "Campaigners reward their communities",
    description: "Building momentum and fostering loyalty.",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-gift"
      >
        <polyline points="20 12 20 22 4 22 4 12" />
        <path d="M2 7h20v5H2z" />
        <path d="M12 22v-5H4" />
        <path d="M12 22v-5H20" />
        <path d="M12 7V2h2.76a2 2 0 0 1 1.77 1.19l.74 1.48A2 2 0 0 0 18 6h3" />
      </svg>
    ),
  },
  {
    title: "Art embedded in impact games enhances engagement",
    description: "Leading to improved fundraising outcomes.",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-dice-5"
      >
        <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
        <path d="M8 8h.01" />
        <path d="M16 16h.01" />
        <path d="M16 8h.01" />
        <path d="M8 16h.01" />
        <path d="M12 12h.01" />
      </svg>
    ),
  },
  {
    title: "Transparent reporting builds trust and credibility",
    description: "Ensuring every contribution has a measurable impact.",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-check-circle"
      >
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
        <path d="m9 11 3 3L22 4" />
      </svg>
    ),
  },
];

export default {
  uniqueFeatures,   
    personas,
    whyUseArt,
}    
